import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RateTemplateService {
  private readonly rateDetailApi = 'api/quick_comment/detail';
  private readonly groupListApi = 'api/quick_comment/group_list';
  private readonly creatorListApi = 'api/quick_comment/create_user_list';
  private readonly createRateApi = 'api/quick_comment/add';
  private readonly updateRateApi = 'api/quick_comment/update';
  private readonly removeRateApi = 'api/quick_comment/remove';
  private readonly rateListApi = 'api/quick_comment/list';
  private readonly createGroupApi = 'api/quick_comment/group_add';
  private readonly updateGroupApi = 'api/quick_comment/group_update';
  private readonly removeGroupApi = 'api/quick_comment/group_remove';
  private readonly updateActiveStatusApi = 'api/quick_comment/update_active';
  

  constructor(private http: HttpClient) { }

  fetchRateDetail (params) {
    const query = new HttpParams({
      fromObject: params
    });

    return this.http.get(this.rateDetailApi, { params: query}) as Observable<any>;
  }

  fetchGroupList () {
    return this.http.get(this.groupListApi) as Observable<any>;
  }

  fetchCreatorList () {
    return this.http.get(this.creatorListApi) as Observable<any>;
  }

  fetchRateList (params) {
    const query = new HttpParams({
      fromObject: params
    });

    return this.http.get(this.rateListApi, { params: query }) as Observable<any>;
  }

  createGroup (params) {
    return this.http.post(this.createGroupApi, params) as Observable<any>;
  }

  updateGroup (params) {
    return this.http.post(this.updateGroupApi, params) as Observable<any>;
  }

  removeGroup (params) {
    return this.http.post(this.removeGroupApi, params) as Observable<any>;
  }

  createRate (params) {
    return this.http.post(this.createRateApi, params) as Observable<any>;
  }

  updateRate (params) {
    return this.http.post(this.updateRateApi, params) as Observable<any>;
  }

  removeRate (params) {
    return this.http.post(this.removeRateApi, params) as Observable<any>;
  }

  updateActiveStatus (params) {
    return this.http.post(this.updateActiveStatusApi, params) as Observable<any>;
  }

  

}
